var cmsForm = function(formID,config={}){
  this.formID = formID;
  this.form = document.getElementById(formID);
  this.config = config;

  if(formID){
    this.layout();
    this.events();
    this.loadDefaults();
    this.holder = window;
    if(this.config.holder){
      this.holder = document.querySelector(this.config.holder);
    }
  }
  else{
    this.formID = "body";
    this.form = document;

  }
}

cmsForm.prototype.events = function(){
  var self = this;

  if(this.form.querySelector("button[type='submit']")){
    this.form.querySelector("button[type='submit']").addEventListener("click",(e)=>{
      e.preventDefault();
      self.submit();
    });
  }

  if(document.querySelector("button[data-formSubmit]")){
    document.querySelector("button[data-formSubmit]").addEventListener("click",function(e){
      e.preventDefault();
      self.submit();
    });
  }
}

cmsForm.prototype.layout = function(){

  this.form.classList.add("cmsForm");
  this.form.setAttribute("enctype","multipart/form-data");
  if(this.form.querySelector("button[type='submit']")){
    this.form.querySelector("button[type='submit']").innerHTML = this.config.submitCTA || "Submit";
  }
  if(document.querySelector("button[data-formSubmit]")){
    document.querySelector("button[data-formSubmit]").innerHTML = this.config.submitCTA || "Submit";
  }

  this.fieldLabels();

  this.checkboxToggles();

  this.imageFields();

  this.selectData();

}

cmsForm.prototype.selectData = async function(){
  var self = this;
  var selects = this.form.querySelectorAll("select");
  for(let i=0;i<selects.length;i++){
    var s = selects[i];
    for(var j=s.options.length-1;j>=0;j--){
      s.options[j].remove();
    }

    if(s.options.length == 0){

      if(s.getAttribute("data-options")){
        var optionurl = s.getAttribute("data-options");
        var optionvalue = s.getAttribute("data-options-value");
        var optionlabel = s.getAttribute("data-options-label");
        var optionkeyvalue = s.getAttribute("data-options-keyvalue");
        var optionkeyname = s.getAttribute("data-options-keyname");



        var res = await fetch(optionurl,{
          method:"GET",
          headers:{
            "Content-Type":"application/json",
            "Accept":"application/json"
          }
        });
        var data = await res.json();

        this.renderSelectData(s,data);


      }
    }
  }
};

cmsForm.prototype.renderSelectData = function(s,data){
  var optionurl = s.getAttribute("data-options");
  var optionvalue = s.getAttribute("data-options-value");
  var optionlabel = s.getAttribute("data-options-label");
  var optionkeyvalue = s.getAttribute("data-options-keyvalue");
  var optionkeyname = s.getAttribute("data-options-keyname");
  var required = s.getAttribute("data-required");
  var optionname = s.getAttribute("name");

  if(s.classList.contains("checkbox")){
    // RENDER AS CHECKBOXES
    var checkboxHolder = document.createElement("div");
    if(s.classList.contains("maxHeight")){
      checkboxHolder.classList.add("maxHeight");
    }
    checkboxHolder.classList.add("checkboxHolder");

    data.forEach((d)=>{
      var option = document.createElement("label");
      option.classList.add("checkbox");
      var checkbox = document.createElement("input");
      checkbox.setAttribute("type","checkbox");
      checkbox.setAttribute("data-options",optionurl);
      checkbox.setAttribute("data-options-value",optionvalue);
      checkbox.setAttribute("data-options-label",optionlabel);
      checkbox.setAttribute("name",optionname);
      if(required){
        checkbox.setAttribute("data-required","required");
      }


      var value = d[optionvalue];
      if(typeof value === "object" && value !== null){
        value = JSON.stringify(value);
      }

      if(optionkeyvalue && optionkeyname){
        var keyvalue = d[optionkeyvalue];
        if(typeof keyvalue === "object" && keyvalue !== null){
          keyvalue = JSON.stringify(keyvalue);
        }

        checkbox.setAttribute("data-options-keyvalue",keyvalue);
        checkbox.setAttribute("data-options-keyname",optionkeyname);
        checkbox.setAttribute("data-json",JSON.stringify(d));



        if(this.editData && this.editData[optionname]){

            var valueArray = this.editData[optionname].split(",");
            var selectedOptions = [];

            if(valueArray.includes(value)){
              checkbox.checked = "checked";
            }


        }

      }


      checkbox.setAttribute("value",value);

      option.innerHTML = d[optionlabel];
      option.append(checkbox);
      checkboxHolder.append(option);


    });
    s.parentNode.insertBefore(checkboxHolder,s);
    checkboxHolder.parentNode.classList.add("checkboxLabel");
    s.remove();
    return;
  }

/*
  data.unshift({
    [optionkeyvalue]:'',
    [optionvalue]:''
  });
*/
  var selectedIndex = false;
  var blankOption = document.createElement("option");
  blankOption.setAttribute("value","");
  blankOption.text = s.getAttribute("placeholder");
  blankOption.selected = true;
  s.prepend(blankOption);
  data.forEach((d,optionIndex)=>{
    var o = document.createElement("option");
    var value = d[optionvalue];
    if(typeof value === "object" && value !== null){
      value = JSON.stringify(value);
    }

    if(optionkeyvalue && optionkeyname){
      var keyvalue = d[optionkeyvalue];
      if(typeof keyvalue === "object" && keyvalue !== null){
        keyvalue = JSON.stringify(keyvalue);
      }

      o.setAttribute("data-options-keyvalue",keyvalue);
      o.setAttribute("data-options-keyname",optionkeyname);
      o.setAttribute("data-json",JSON.stringify(d));

      if(this.editData && this.editData[optionkeyname]){
        if(s.multiple){
          var valueArray = this.editData[optionkeyname].split(",");
          var selectedOptions = [];


          if(valueArray.includes(keyvalue)){
            o.selected = "selected";
            o.setAttribute("selected","selected");
          }

        }
        else{

          if(this.editData[optionkeyname] == keyvalue ){
            o.selected = true;
            s.selectedIndex = optionIndex;
            selectedIndex = optionIndex;
            o.setAttribute("selected","selected");

          }
        }

      }
      if(this.editData && this.editData[optionname]){

        if(this.editData[optionname] == value ){
          o.selected = true;
          s.selectedIndex = optionIndex;
          selectedIndex = optionIndex;
          o.setAttribute("selected","selected");

        }
      }
    }


    o.setAttribute("value",value);
    o.innerHTML = d[optionlabel];

    s.append(o);




  });
  if(selectedIndex){
    s.selectedIndex = selectedIndex+1;
  }



};

cmsForm.prototype.stripslashes = function(str) {

  return (str + '').replace(/\\(.?)/g, function (s, n1) {
    switch (n1) {
    case '\\':
      return '\\';
    case '0':
      return '\u0000';
    case '':
      return '';
    default:
      return n1;
    }
  });
}

cmsForm.prototype.fieldLabels = function(){
  var fields = this.getFields();
  for(let i =0;i<fields.length;i++){
    var f = fields[i];
    var label = f.getAttribute("placeholder");
    if(label && label !== "" && !f.parentNode.querySelector("span")){
      var span = document.createElement("span");
      if(f.getAttribute("data-required") == "true"){
        label += " <div class='requiredLabel'>*</div>";
        f.setAttribute("placeholder",f.getAttribute("placeholder") + " *");
      }

      span.innerHTML = label;
      f.parentNode.insertBefore(span,f);
      f.parentNode.classList.add("withLabel");
    }


    var checkInput = (f) => {
      if(f.value == ""){
        f.parentNode.classList.remove("withLabel");
      }
      else if(f.value !== ""){

        f.parentNode.classList.add("withLabel");

      }
    };

    f.addEventListener("keyup",function(e){
      var f = e.currentTarget;
      checkInput(f);
    });
    checkInput(f);



  }
};

cmsForm.prototype.checkboxToggles = function(){
  var checkboxToggles = document.querySelectorAll("input[data-checkbox-toggle]");
  for(let i=0;i<checkboxToggles.length;i++){

    var c = checkboxToggles[i];
    var toggleReverse = c.getAttribute("data-checkbox-toggle-reverse");

    if(c.checked){
      document.getElementById(c.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "none" : "block";
    }
    else{
      document.getElementById(c.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "block" : "none";
    }

    c.addEventListener("click",function(e){
      if(e.currentTarget.checked){
        document.getElementById(e.currentTarget.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "none" : "block";
      }
      else{
        document.getElementById(e.currentTarget.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "block" : "none";
      }
    });
  }
};

cmsForm.prototype.edit = async function(data){
  var self = this;

  this.editData = data;
  if(this.config.editData){
    var res = await fetch(this.config.editData+data.key);
    //var res = await fetch(this.config.editData);
    data = await res.json();
    this.editData = data;
  }
  var fields = this.getFields();



  if(data.key){
    var inputEditKey = this.form.querySelector("input[name='key']");
    if(!inputEditKey){
      var inputEditKey = document.createElement("input");
      inputEditKey.setAttribute("type","hidden");
      inputEditKey.setAttribute("name","key");
      this.form.append(inputEditKey);
    }
    inputEditKey.value = JSON.stringify(data.key);

  }



  if(this.form.querySelector("button[type='submit']")){
     this.form.querySelector("button[type='submit']").innerHTML = this.config.editCTA || "Submit";
  }

  if(document.querySelector("button[data-formSubmit]")){
     document.querySelector("button[data-formSubmit]").innerHTML = this.config.editCTA || "Submit";
  }

  if(this.config.beforeEdit){
    this.config.beforeEdit(data);
  }


  for(let i =0; i<fields.length;i++){
    var f = fields[i];
    if(this.config.editIgnore && this.config.editIgnore.includes(f.getAttribute("name"))){
      continue;
    }


    var fieldValue = data[f.getAttribute("name")] ? data[f.getAttribute("name")] : "";

    if(f.getAttribute("type") == "checkbox"){

      if(this.form.querySelectorAll("input[name='"+f.name+"']").length > 1){
        // Multiple Checkboxes
        fieldValueArray = fieldValue.split(",");

        if(fieldValueArray.includes(f.value)){
          f.checked = true;
        }
      }
      else{
        if(fieldValue == ""){
          f.checked = false;
          f.removeAttribute("checked");
        }
        else{
          f.setAttribute("checked","checked");
          f.checked = true;
        }
      }
    }
    else if(f.getAttribute("type") == "select"){

    }
    else{
            f.value = fieldValue;
    }

    if(f.multiple){
      var valueArray = fieldValue.split(",");
      var selectedOptions = [];

      Array.from(f.options).map(o=>{
        if(valueArray.includes(o.value)){
          o.selected = "selected";
          o.setAttribute("selected","selected");
        }
      });



    }
    else if(f.options){



      await new Promise((resolve,reject)=>{
        setTimeout(()=>{
          Array.from(f.options).forEach((o,optionIndex)=>{
            if(o.value == fieldValue){
              o.setAttribute("selected","selected");
              o.selected = "selected";
              f.selectedIndex = optionIndex;

            }
          });
          resolve(true);
        },100);

      });



    }




    var imageField = this.form.querySelector(".imageField[data-name='"+f.getAttribute("name")+"']");
    if(imageField && data[f.getAttribute("name")]){
      if(!imageField.querySelector("img")){
        self.populateImageField(imageField,data[f.getAttribute("name")]);
      }
    }
  }
  this.checkboxToggles();
  this.fieldLabels();

};

cmsForm.prototype.populateImageField = function(imageField,value){
  imageField.querySelector("button").innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Cloud Upload</title><path d='M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M320 255.79l-64-64-64 64M256 448.21V207.79'/></svg> Change "+imageField.getAttribute("data-label");
  var imagePreview = document.createElement("img");
  imagePreview.setAttribute("src",value);
  imageField.append(imagePreview);
  imageField.querySelector("input[type='hidden']").value = value;

};

cmsForm.prototype.imageFields = function(){
  var self = this;
  var imageFields = this.form.getElementsByClassName("imageField");

  for(let i =0;i<imageFields.length;i++){
    var f = imageFields[i];


      f.innerHTML = "";
      var name = f.getAttribute("data-name");
      var label = f.getAttribute("data-label");
      var url = f.getAttribute("data-url");
      var helpText = f.getAttribute("data-help");



      var input = document.createElement("input");
      input.setAttribute("type","hidden");
      input.setAttribute("name",name);

      var imageInput = document.createElement("input");
      imageInput.setAttribute("data-fieldName",name);
      imageInput.setAttribute("type","file");
      imageInput.style.display = "none";
      var imageInputID = "image_"+Math.random(0,999999);
      imageInput.setAttribute("id",imageInputID);
      document.querySelector("body").append(imageInput);

      imageInput.addEventListener("change",function(e){
        var f = document.querySelector("div[data-name='"+e.currentTarget.getAttribute("data-fieldName")+"']");
        self.uploadImage(e,f);
      });



      var button = document.createElement("button");
      button.setAttribute("type","button");
      button.setAttribute("data-imageInput",imageInputID);
      button.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Cloud Upload</title><path d='M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M320 255.79l-64-64-64 64M256 448.21V207.79'/></svg> Upload "+label;

      button.addEventListener("click",function(e){
        e.preventDefault();
        document.getElementById(e.currentTarget.getAttribute("data-imageInput")).click();
      });




      f.append(input);
      f.append(button);

      if(helpText){
        var helpDiv = document.createElement("div");
        helpDiv.classList.add("helpText");
        helpDiv.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Information Circle</title><path d='M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z' fill='none' stroke='currentColor' stroke-miterlimit='10' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M220 220h32v116'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-miterlimit='10' stroke-width='32' d='M208 340h88'/><path d='M248 130a26 26 0 1026 26 26 26 0 00-26-26z'/></svg> "+helpText;
        f.append(helpDiv);
      }


  }
};

cmsForm.prototype.resetImage = function(field){
  var imageEl = field.querySelector("img");
  if(imageEl){
    imageEl.remove();
  }

  var imageInput = field.querySelector("input[type='hidden']");
  imageInput.value = "";
};

cmsForm.prototype.uploadImage = function(e,field){
  var allowedTypes = field.getAttribute("data-type") || "image/jpeg,image/jpg,image/png,image/webp,image/gif";
  allowedTypes = allowedTypes.split(",");
  var fileSize = field.getAttribute("data-size") || 2000000;
  fileSize = parseInt(fileSize);
  if(!allowedTypes.includes(e.target.files[0].type)){
    this.errorMessage("Invalid File Type");
    return false;
  }

  if(e.target.files[0].size > fileSize){
    this.errorMessage("Image too Large");
    return false;
  }

  var button = field.querySelector("button");
  button.innerHTML = "Uploading...";

  var reader = new FileReader();
  reader.addEventListener("load",()=>{

    var src = reader.result;
    this.setPreviewImage(field,src);
  });

  var data = new FormData();

  var imageWidth = field.getAttribute("data-width");
  var imageHeight = field.getAttribute("data-height");

  var mobileWidth = field.getAttribute("data-mobileWidth");
  var mobileHeight = field.getAttribute("data-mobileHeight");

  if(imageWidth && imageHeight){
    data.append("width",imageWidth);
    data.append("height",imageHeight);
  }


  if(mobileWidth && mobileHeight){
    data.append("mobileWidth",mobileWidth);
    data.append("mobileHeight",mobileHeight);
  }



  data.append('file', e.target.files[0])

  fetch(field.getAttribute("data-url"), {
    method: 'POST',
    body: data
  }).then(res=>res.json())
  .then(data=>{
    this.setImage(field,data.imageUrl);
    reader.readAsDataURL(e.target.files[0]);
  });

};

cmsForm.prototype.setPreviewImage = function(field,src){
  var imageEl = field.querySelector("img");
  if(imageEl){
    imageEl.remove();
  }

  var previewImage = document.createElement("img");
  previewImage.setAttribute("src",src);
  field.append(previewImage);
};

cmsForm.prototype.setImage = function(field,imageUrl){
  var button = field.querySelector("button");
  var imageInput = field.querySelector("input[type='hidden']");
  imageInput.value = imageUrl;
  button.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Cloud Upload</title><path d='M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M320 255.79l-64-64-64 64M256 448.21V207.79'/></svg> Upload Image";

};

cmsForm.prototype.submit = function(){
  var self = this;

  if(this.config.beforeValidate){
    this.config.beforeValidate();
  }

  if(this.validate()){


    var formData = new FormData();
    var fields = this.getFields();
    fields.forEach(f=>{


      if(f.getAttribute("type") == "checkbox"){

        if(f.checked){
          if(f.getAttribute("data-options-keyname") && f.getAttribute("data-options-keyvalue")){
            var keyName = f.getAttribute("data-options-keyname");
            var value = f.value;
            var keyValue = f.getAttribute("data-options-keyvalue");

            if(formData.has(f.getAttribute("name"))){
              value = formData.get(f.getAttribute("name")) + "," + value;
              keyValue = formData.get(keyName) + "," + keyValue;
              formData.set(keyName,keyValue);
              formData.set(f.getAttribute("name"),value);
            }
            else{
              formData.append(keyName,keyValue);
              formData.append(f.getAttribute("name"),value);
            }

          }
          else{
            formData.append(f.getAttribute("name"),f.getAttribute("data-value"));
          }

        }

        if(f.getAttribute("data-includeUnchecked")){
          formData.append(f.getAttribute("name"),"");
        }



      }
      else if(f.getAttribute("data-options-keyname") && f.getAttribute("data-options-keyvalue")){
        var keyName = f.getAttribute("data-options-keyname");
        var option = f.options[f.selectedIndex];
        var value = f.value;
        var keyValue = option.getAttribute("data-options-keyvalue");

        if(f.selectedOptions.length > 1){
          value = Array.from(f.selectedOptions).map(o=>{ return f.options[o.index].value; }).join(",");
          keyValue = Array.from(f.selectedOptions).map(o=>{ return f.options[o.index].getAttribute("data-options-keyvalue"); }).join(",");
        }

        formData.append(keyName,keyValue);
        formData.append(f.getAttribute("name"),value);


      }
      else{
        if(self.config.editIgnore && self.config.editIgnore.includes(f.getAttribute("name")) && f.value == ""){

        } else {
          formData.append(f.getAttribute("name"),f.value);
        }
      }

    });

    if(this.config.validateOnly){
      if(this.config.callback){
        this.config.callback(formData);
      }
      return false;
    }


    if(this.form.querySelector("input[name='key']"))
    {
      this.showLoader(this.config.editMessage || "Modifying");
    }
    else{
      this.showLoader(this.config.submitMessage || "Submitting");
    }


    if(this.config.beforeSubmit){
      formData = this.config.beforeSubmit(formData);
    }

//    for(let pairs of formData.entries()){
//      console.log(pairs[0] + ": " + pairs[1]);
//    }



    fetch(this.form.getAttribute("action"),{
      method:"POST",
      body:formData,
      headers:{
        Accept:"application/json",
        //"Content-Type":"application/json"
      }
    }).then(res=>res.json())
    .then(data=>{

      if(data.error){
        self.form.scrollIntoView(true);

        self.loader.innerHTML = '<div class="loaderHolder"><br/>'+data.error+'</div>';

      }
      else{
        if(self.config.callback){
          self.config.callback(data);
        }
        //self.reset();
        //self.loadDefaults();
        self.form.classList.remove("hide");
        console.log(self.form.querySelector(".formSuccess"));
        if(self.form.querySelector(".formSuccess")){
          console.log("HAS FORM SUCCESS");
        }
        self.form.querySelector(".formSuccess") && self.form.querySelector(".formSuccess").classList.add("show");
        if(data.message && self.form.querySelector(".formSuccess")){
          self.form.querySelector(".formSuccess").innerHTML = data.message;


        }
        if(self.config.errorScrollTop){
          self.holder.scrollTo({top:self.config.errorScrollTop,behavior:"smooth"});
        }
        else{
          var formBounds = self.form.getBoundingClientRect();
          var formTop = formBounds.top+window.scrollY-100;

          if(this.config.scrollOffset){
            formTop = formTop - this.config.scrollOffset;
          }

          if(formTop > window.scrollY){
            formTop = window.scrollY;
          }
          self.holder.scrollTo({top:formTop,behavior:"smooth"});
        }

      }


    });



  }
};

cmsForm.prototype.showLoader = function(message){
  return;
  var self = this;
  if(this.config.loaderID){
    this.loader = document.getElementById(this.config.loaderID);
  }
  else{
    this.form.classList.add("hide");
    if(this.loader){
      this.loader.remove();
    }

    this.loader = document.createElement("div");
    this.loader.classList.add("cmsLoader");

    this.loader.innerHTML = '<div class="loaderHolder"><div class="sk-folding-cube"><div class="sk-cube1 sk-cube"></div><div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube"></div></div><br/>'+message+'</div>';


    this.form.parentNode.insertBefore(this.loader,this.form);
  }

  self.holder.scrollTo({top:0,behavior:"smooth"});
  setTimeout(function(){
    self.loader.classList.add("show");



  },500);

  setTimeout(function(){
    self.form.style.height = "0px";

  },501);

  setTimeout(function(){

  },502);



}

cmsForm.prototype.reset = function(){
  this.editData = false;
  this.form.querySelector(".formSuccess") && this.form.querySelector(".formSuccess").classList.remove("show");
  this.form.style.height = "auto";
  this.form.classList.remove("hide");
  if(this.form.querySelector("button[type='submit']")){
     this.form.querySelector("button[type='submit']").innerHTML = this.config.submitCTA || "Submit";
  }


  this.loader && this.loader.classList.remove("show");
  this.layout();

  var inputEditKey = this.form.querySelector("input[name='key']");
  if(inputEditKey){
    inputEditKey.remove();
  }

  var fields = this.getFields();
  for(let i = 0; i<fields.length;i++){
    if(this.config.editIgnore && this.config.editIgnore.includes(fields[i].getAttribute("name"))){

      continue;
    }

    if(fields[i].getAttribute("type","checkbox")){
      fields[i].checked = false;
    } else {
      fields[i].value = "";
    }
  }
  this.loadDefaults();

}

cmsForm.prototype.loadDefaults = function(){
  if(!this.config.defaultDataUrl) return;
  var self = this;
  fetch(this.config.defaultDataUrl,{
    method:"GET",
    headers:{
      Accept:"application/json"
    }
  }).then(res=>res.json())
  .then(data=>{
    self.edit(data,true);
  });

};


cmsForm.prototype.getFields = function(){
  var inputs  = this.form.querySelectorAll("input");
  var textareas = this.form.querySelectorAll("textarea");
  var selects = this.form.querySelectorAll("select");
  var fields = [...inputs,...textareas,...selects];
  return fields;
}

cmsForm.prototype.validate = function(){
  var fields = this.getFields();

  var errorMessage = this.form.getElementsByClassName("errorMessage");
  if(errorMessage.length > 0){
    errorMessage[0].remove();
  }

  var valid = true;
  for(let i=0;i<fields.length;i++){
    var f = fields[i];
    f.classList.remove("error");

    if(f.getAttribute("data-fieldQuerySelector")){
      var associatedFields = document.querySelectorAll(f.getAttribute("data-fieldQuerySelector"))
      for(let q=0;q<associatedFields.length;q++){
        associatedFields[q].classList.remove("error");
      }

    }
    if(f.getAttribute("data-required")){
      if(f.type == "checkbox"){
        var checked = this.form.querySelectorAll("input[name='"+f.getAttribute("name")+"']:checked");
        if(checked.length > 0){
          f.parentNode.parentNode.classList.remove("error");



        } else {
          valid = false;
          f.parentNode.parentNode.classList.add("error");
        }


      }
      else{
        if(f.value == ""){
          valid = false;

          if(f.getAttribute("data-fieldQuerySelector")){
            var associatedFields = document.querySelectorAll(f.getAttribute("data-fieldQuerySelector"));
            for(let q=0;q<associatedFields.length;q++){
              associatedFields[q].classList.add("error");
            }


          }

          f.classList.add("error");
        }
      }

    }
  }
  if(!valid){
    this.errorMessage("Missing Required Fields");

  }

  return valid;
};

cmsForm.prototype.errorMessage = function(message){
  if(this.errorDiv){
    this.errorDiv.remove();
  }
  if(this.errorTimer){
    clearTimeout(this.errorTimer);
  }
  var self = this;
  this.errorDiv = document.createElement("div");
  this.errorDiv.innerHTML = message;
  this.errorDiv.classList.add("errorMessage");
  this.form.append(this.errorDiv);
  setTimeout(function(){
    self.errorDiv.classList.add("show");
  },100);

  this.errorTimer = setTimeout(function(){
    self.errorDiv.classList.remove("show");
  },5000);

  var firstError = this.form.querySelector(".error");
  if(this.config.errorScrollTop){
    self.holder.scrollTo({top:this.config.errorScrollTop,behavior:"smooth"});
  }
  else if(firstError){
    self.holder.scrollTo({top:firstError.getBoundingClientRect().top + window.scrollY-120,behavior:"smooth"});
  }
  else{
    self.holder.scrollTo({top:0,behavior:"smooth"});
  }
  //this.form.scrollIntoView(true);
};
